module.exports = __webpack_public_path__ + "static/img/banner_2.7c1c49e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/banner_2.png
// module id = SIXX
// module chunks = 1